import React from 'react';
import AboutItem from './AboutItem';
import './index.css';

const AboutGeneral = [{
        tag:['EXCELLENCE', 'performance', 'style', 'exclusivity'],
        title: 'Stallion is an experience unmatched',
        text: 'We place a special empahsis on the combination of the highest level of service of the personal driver, luxury, and equipment of the vehicle. All of our drivers are bound by a contract of confidentiality and are perfectly prepared to handle any situation. LaFerrari Aperta ensure comfort and performance for an exhilarating and fun ride.',
        imgURL: 'about__experience.png',
        reverse: false
    },
    {
        tag:['Discrete and personalized '],
        title: ['Stallion is personal and descreet'],
        text: 'Every journey is a unique opportunity to build a rapport and provide ongoing excellent service. Whether your goal is a perfect presentation, fun out on the town, of just want to be fucking cool. Stallion will provide you a personalized agenda of your upcomming journey.',
        imgURL: 'about__persone.jpg',
        reverse: true
    }]
const About = () => {
    return (
        <div className="about">
            <ul className="about__list">
                {
                    AboutGeneral.map((item, index) => {
                        return <li className={item.reverse ? "about__item-reverse" : "about__item"} key={index}><AboutItem data={item}/></li>
                    })
                }
            </ul>
        </div>
    );
}

export default About;
